import { Column } from '@components/LinearLayout';
import { SectionContainer, Title, Description } from './styles';
import { useTranslation } from 'react-i18next';

const OurConceptSection = () => {
  const { t } = useTranslation();
  return (
    <section>
      <SectionContainer>
        <Column $gap="1.5rem" $maxWidth="842px">
          <Title>{t('our-concept-title')}</Title>
          <Description>{t('our-concept-description')}</Description>
        </Column>
      </SectionContainer>
    </section>
  );
};

export default OurConceptSection;
